import React from 'react'

export const ScrollContext = React.createContext(null as any)